export function renderEmptyContainer(document) {
    const emptyContainer = document.createElement('span');
    return { element: emptyContainer, type: 'inner' };
}
//# sourceMappingURL=render-empty-container.js.map